module.exports = __webpack_public_path__ + "static/media/img90_R.c9cc9078.jpg";